import React from 'react';
import PropTypes from 'prop-types';
import { GatewayRegistry } from './GatewayRegistry.js';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/**
 * Modified from: https://github.com/cloudflare/react-gateway/blob/master/src/Gateway.js
 */

var Gateway = /*#__PURE__*/function (_React$Component) {
  _inherits(Gateway, _React$Component);

  var _super = _createSuper(Gateway);

  function Gateway(props, context) {
    var _this;

    _classCallCheck(this, Gateway);

    _this = _super.call(this, props, context);

    _defineProperty(_assertThisInitialized(_this), "gatewayRegistry", void 0);

    _defineProperty(_assertThisInitialized(_this), "id", void 0);

    _this.gatewayRegistry = context.gatewayRegistry;
    return _this;
  } ////Prism React 18 upgrade modification: componentWillMount changed to componentDidMount

  /*componentWillMount() {
    this.id = this.gatewayRegistry.register(
      this.props.into,
      this.props.children
    );
    this.renderIntoGatewayNode(this.props);
  }*/


  _createClass(Gateway, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.id = this.gatewayRegistry.register(this.props.into, this.props.children);
      this.renderIntoGatewayNode(this.props);
    } //Prism React 18 upgrade modification: componentWillReceiveProps changed to componentDidUpdate

    /*componentWillReceiveProps(props) {
      this.gatewayRegistry.clearChild(this.props.into, this.id);
      this.renderIntoGatewayNode(props);
    }*/

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.into !== this.props.into) {
        this.gatewayRegistry.clearChild(prevProps.into, this.id);
        this.id = this.gatewayRegistry.register(this.props.into, this.props.children);
      }

      this.renderIntoGatewayNode(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.gatewayRegistry.unregister(this.props.into, this.id);
    }
  }, {
    key: "renderIntoGatewayNode",
    value: function renderIntoGatewayNode(props) {
      this.gatewayRegistry.addChild(this.props.into, this.id, props.children);
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return Gateway;
}(React.Component);

_defineProperty(Gateway, "contextTypes", {
  gatewayRegistry: PropTypes.instanceOf(GatewayRegistry).isRequired
});

export { Gateway };
